import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}`,
  [],
  [authentication],
  [],
  false,
  60000,
  true,
);

export default {
  /**
   * @returns {AxiosPromise}
   */
  getSession() {
    return conduit.get('/session', [], []);
  },
};



// WEBPACK FOOTER //
// ./src/services/twenty-service.js